import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DealerProfile } from '@app/domain/model/dealer-profile';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommentaryService } from './commentary.service';
import { DealerProfileService } from '../../../dealer/profile/dealer-profile.service';
import { take, takeUntil } from 'rxjs/operators';
import { ReplaySubject } from 'rxjs';

@Component({
  templateUrl: './admin-dealer-profile.component.html',
  styleUrls: ['./admin-dealer-profile.component.scss']
})
export class AdminDealerProfileComponent implements OnInit, OnDestroy {

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  activeColumn: number;

  profile: DealerProfile;

  readonly numberOfDisplayedRows = 10;
  isTablePaginationHidden = true;

  commentForm: FormGroup;

  constructor(private readonly formBuilder: FormBuilder,
              private route: ActivatedRoute,
              private profileService: DealerProfileService,
              private commentaryService: CommentaryService) {
  }

  ngOnInit() {
    this.route.parent.data.pipe(takeUntil(this.destroyed$)).subscribe((data) => {
      this.loadProfile(data.profile);
    });
    this.commentForm = this.formBuilder.group({
      comment: ['', [Validators.required, Validators.maxLength(4000)]]
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  loadProfile(profile: DealerProfile): void {
    this.profile = profile;
    if (this.profile.comments.length < this.numberOfDisplayedRows) {
      this.isTablePaginationHidden = true;
    } else {
      this.isTablePaginationHidden = false;
    }

  }
  addComment() {
    if (this.commentForm.invalid) {
      return;
    }
    const commentary = this.commentForm.controls['comment'].value;
    this.commentaryService
      .addCommentary(this.profile.id, commentary)
      .subscribe(__ =>
        this.profileService
          .getDealerProfile(this.profile.id)
          .subscribe((profile: DealerProfile) => {
            this.loadProfile(profile);
            this.commentForm.controls['comment'].reset('');
          }));
  }

  hasError(controlName: string, validation?: string) {
    const control = this.commentForm.controls[controlName];
    if (validation) {
      return control.errors[validation];
    } else {
      return control.errors && control.touched;
    }
  }

}
